import Backbone from 'backbone'
import template from './buttons-test.hbs'
import BusyButton from 'scoreboard/components/busy-button'
import RefreshButton from 'scoreboard/components/refresh-button'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import _ from 'lodash'

var TestButtonView = Backbone.View.extend({
	className: 'admin table-hack display-layout admin-test-view admin-test-buttons',

	events: {
		'click .busy-button-panel button:not(.refresh-button):not(.refresh-button-errored)': 'cycleLoadingStates',
		'click .refresh-button': 'cycleRefreshButtonStates',
		'click .busy-button-panel .refresh-button-errored': 'cycleErrorRefreshButtonStates',
		'click .toggle-hovered-state': 'onClickCovertHoverToggle'
	},

	render: function () {
		let covertButtons = ['add','delete','edit','upload','clock','send-to','note',
							'settings','wob-align-left','wob-align-center','wob-align-right',
							'wob-align-top','wob-align-middle','wob-align-bottom','swap','snap',
							'refresh', 'import-data', 'download', 'done', 'not-allowed',
							'impact-relation-missing-data']
		let toolbarButtons = [{
			icon: 'bookmark'
		},{
			icon: 'bookmark-filled'
		},{
			icon: 'info'
		},{
			icon: 'warn'
		},{
			icon: 'clock'
		},{
			icon: 'send-to',
			menuIcon: true
		}]

		this.$el.empty().append(template({
			covertButtons,
			toolbarButtons
		}))

		// Set up labeled toggler
		this.toggle = new LabeledToggle({
			options: [{
				value: 'left',
				label: 'Left'
			},{
				value: 'middle',
				label: 'Middle'
			},{
				value: 'right',
				label: 'Right'
			}]
		})
		this.$('.labeled-toggle-container').append(this.toggle.el)
		this.toggle.render()

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
		this.refreshButtons = []
		this.refreshButtons.push(new RefreshButton({el: this.$('.refresh-button-1')}))
		this.refreshButtons.push(new RefreshButton({el: this.$('.refresh-button-2')}))
		this.refreshButtons.push(new RefreshButton({el: this.$('.refresh-button-3')}))
		this.refreshButtons.push(new RefreshButton({el: this.$('.refresh-button-4')}))

		return this
	},

	onClickCovertHoverToggle(e) {
		let panel = this.$(e.target).closest('.panel')
		panel.find('.button-covert').toggleClass('is-hovered')
	},

	cycleLoadingStates: function(e) {
		var busyButton = new BusyButton({el: this.$(e.target)}).loading()
		setTimeout(() => busyButton.done(), 1000)
		busyButton.on('animation-complete', () => busyButton.toggle(true))
	},

	cycleRefreshButtonStates(e) {
		_.each(this.refreshButtons, button => {
			if (button.el == e.target.closest('.refresh-button')) {
				button.loading()
				setTimeout(() => {
					if (button.$el.hasClass('error-test')) {
						button.error()
					} else {
						button.done()
					}
				}, 1000)
				return
			}
		})
	}
})

export default TestButtonView
